import { z } from 'zod';

// ─── User ─────────────────────────────────────────────────────────────────────

export const UserSchema = z.object({
  id: z.string().uuid(),
  firebaseUid: z.string(),
  displayName: z.string().min(1).max(100),
  email: z.string().email(),
  avatarUrl: z.string().url().optional(),
  isAdmin: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type User = z.infer<typeof UserSchema>;

/** Shape of the verified token claims attached to authenticated requests */
export const AuthTokenSchema = z.object({
  uid: z.string(),
  email: z.string().email().optional(),
  name: z.string().optional(),
  picture: z.string().url().optional(),
  admin: z.boolean().optional(),
});
export type AuthToken = z.infer<typeof AuthTokenSchema>;

export const GlobalRoleKeySchema = z.enum(['viewer', 'manager', 'admin', 'super_admin']);
export type GlobalRoleKey = z.infer<typeof GlobalRoleKeySchema>;

export const MeResponseSchema = z.object({
  uid: z.string(),
  email: z.string().email().optional(),
  name: z.string().optional(),
  picture: z.string().url().optional(),
  admin: z.boolean().optional(),
  roles: z.object({
    global: z.array(GlobalRoleKeySchema),
    station: z.array(
      z.object({
        stationSlug: z.string(),
        roleKey: z.string(),
        data: z.record(z.string(), z.unknown()),
      }),
    ),
  }),
  permissions: z.object({
    global: z.array(z.string()),
    station: z.record(z.string(), z.array(z.string())),
  }),
});
export type MeResponse = z.infer<typeof MeResponseSchema>;
